(function () {
  'use strict';

  angular
    .module('crewFlyingDetailsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewFlyingDetailsReport', {
        url: '/crew-flying-details-report',
        views: {
          'crewFlyingDetailsReportView': {
            templateUrl: 'crew-flying-details-report/views/crew-flying-details-report.tpl.html',
            controller: 'CrewFlyingDetailsReportCtrl',
            controllerAs: 'crewFlyingDetailsReport'
          }
        }
      });
  }
}());
